module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/377.51a1e8a7.png";